var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column dropdown-search" },
    [
      _c(
        "el-dropdown",
        {
          attrs: { trigger: "click" },
          on: { command: _vm.setValue },
          scopedSlots: _vm._u([
            {
              key: "dropdown",
              fn: function() {
                return [
                  _c(
                    "el-dropdown-menu",
                    { staticClass: "pt-0 dropdown-search-dropdown-menu" },
                    [
                      _c(
                        "div",
                        { staticClass: "pt-2 pb-2 pl-3 pr-3 gray-0-bkg" },
                        [
                          _c("el-input", {
                            staticClass: "input-search-dropdown",
                            attrs: {
                              placeholder: _vm.$t.__(
                                "inputs.custom.DropdownSearch.search"
                              )
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "suffix",
                                fn: function() {
                                  return [
                                    _c("i", {
                                      staticClass: "el-input__icon icon-search"
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.searchInput,
                              callback: function($$v) {
                                _vm.searchInput = $$v
                              },
                              expression: "searchInput"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "gray-60 fs-3 semibold p-3" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$l10n.__("Informations")))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.search, function(item) {
                        return !item.isSelected
                          ? _c(
                              "el-dropdown-item",
                              {
                                key: item.name,
                                staticClass: "gray-100",
                                attrs: { command: item }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.label) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("el-input", {
            staticClass: "wp-10",
            attrs: {
              readonly: "",
              value: _vm.pref.label,
              placeholder: _vm.$t.__(
                "inputs.custom.DropdownSearch.select_preference_to_update"
              ),
              "suffix-icon": "el-icon-arrow-down"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }